import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import api from "./api";

/**
 * usePresence — pings the backend every 60s while the user is logged in to keep
 * their last_seen timestamp fresh. This powers the "online now" counter and
 * the live online users list.
 */
export default function usePresence() {
  const { user } = useAuth();
  useEffect(() => {
    if (!user) return;
    const ping = () => api.post("/heartbeat", { path: window.location.pathname }).catch(() => {});
    ping();
    const t = setInterval(ping, 60_000);
    const onVisible = () => { if (!document.hidden) ping(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", onVisible); };
  }, [user]);
}
